// Unpublished Work © 2022-2024 Deere & Company.

import React from 'react';
import PropTypes from 'Utils/prop-type-utils';
import ValidationInput from 'Ui/components/common/form/validation-input';
import ValidationMultiSelect from 'Ui/components/common/form/validation-multi-select';
import SortedMultiSelect from 'Ui/components/common/form/sorted-multi-select';

function UpsertEquipmentForm(props) {
    const {
        equipmentName,
        modelItems,
        shouldDisplayModelSelector,
        selectedModel,
        serialNumber,
        setEquipmentName,
        setSerialNumber,
        setSelectedModel,
        setValid,
        translations
    } = props;

    return (
        <form className='equipment-dialog-form upsert-equipment'>
            {
                shouldDisplayModelSelector && <div className='settings-block-row'>
                    <ValidationMultiSelect
                        className='multiselect'
                        component={SortedMultiSelect}
                        containerHeight={300}
                        dropUpThreshold={350}
                        enableVirtualization={true}
                        items={modelItems}
                        label={translations.MODEL}
                        labels={{
                            placeholder: translations.ONLINK_SELECT_MODEL,
                            emptyList: translations.NO_ITEMS,
                            noItemMatch: translations.NO_RESULTS_FOUNDS
                        }}
                        name='selectedModel'
                        onChange={(selectedIds) => setSelectedModel(selectedIds[0])}
                        selectedIds={[selectedModel]}
                        setValid={setValid}
                        single={true}
                        translations
                    />
                </div>
            }
            <div className='settings-group mobile'>
                <ValidationInput
                    label={translations.NAME}
                    name='equipmentName'
                    onChange={(e) => setEquipmentName(e.target.value)}
                    required={true}
                    setValid={setValid}
                    tabIndex={0}
                    value={equipmentName}
                />
                <ValidationInput
                    label={translations.ONLINK_SERIAL_NUMBER}
                    name='serialNumber'
                    onChange={(e) => setSerialNumber(e.target.value)}
                    required={true}
                    setValid={setValid}
                    tabIndex={0}
                    value={serialNumber}
                />
            </div>
        </form>
    );
}

UpsertEquipmentForm.propTypes = {
    equipmentName: PropTypes.string,
    modelItems: PropTypes.array,
    selectedModel: PropTypes.object,
    serialNumber: PropTypes.string,
    setEquipmentName: PropTypes.func,
    setSelectedModel: PropTypes.func,
    setSerialNumber: PropTypes.func,
    setValid: PropTypes.func,
    shouldDisplayModelSelector: PropTypes.bool,
    translations: PropTypes.translations
};

export default UpsertEquipmentForm;
